import { memo } from "react";
import { Button } from "primereact/button";

import { useSettingsContext } from "sj-ui-toolkit/src/atlas/contexts/Settings/SettingsContextProvider";

import { PROFICIENCY_THRESHOLDS } from "./assessmentHelpers";
import { ScoreHistoryChart } from "./ScoreHistoryChart";
import { CompetencyScore } from "./CompetencyScore";
import { TopicList } from "./TopicList";
import S from "./Assessments.module.scss";

/** Memoized detailed results card for a section that has been taken */
const SectionDetail = memo(({ sectionData, onRetake }) => {
  const {
    section,
    latestScorePercent,
    latestTeamAveragePercent,
    timesTaken,
    scores,
    topicScores,
    inProgressExam,
  } = sectionData;
  const { isFeatureEnabled } = useSettingsContext();
  const userInitiatedExams = isFeatureEnabled("self_assessments");

  const proficiencies = topicScores.filter(
    t => (t.scorePercent ?? 0) >= PROFICIENCY_THRESHOLDS.GROWTH_OPPORTUNITIES
  );
  const growthOpportunities = topicScores.filter(
    t => (t.scorePercent ?? 0) < PROFICIENCY_THRESHOLDS.GROWTH_OPPORTUNITIES
  );

  const timesLabel = timesTaken === 1 ? "Taken once" : `Taken ${timesTaken} times`;

  return (
    <div className="border-t mt-12 pt-4 border-surface-300">
      <h2 className={`atlas-h2 ${S.sectionHeader}`}>{section.title}</h2>
      <div className="text-muted-aaa body-sm">{timesLabel}</div>

      <div className={S.sectionContent}>
        <ScoreHistoryChart scores={scores} />
        <div>
          <CompetencyScore
            latestScorePercent={latestScorePercent}
            latestTeamAveragePercent={latestTeamAveragePercent}
          />
          {userInitiatedExams && (
            <Button
              label={inProgressExam ? "Continue Assessment" : "Retake Assessment"}
              outlined
              severity="secondary"
              className="mt-6"
              onClick={() => onRetake(section.path)}
            />
          )}
        </div>
        <TopicList heading="Proficiencies" topics={proficiencies} variant="proficiency" />
        <TopicList heading="Growth Opportunities" topics={growthOpportunities} variant="growth" />
      </div>
    </div>
  );
});

SectionDetail.displayName = "SectionDetail";

export { SectionDetail };
